module.exports = __webpack_public_path__ + "static/media/banner_420x230_11.80ffba0d.jpg";